var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSelfLearningBook = function SvgSelfLearningBook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FAD7D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.919 17.2762H11.6629C10.7426 17.2762 10 18.0189 10 18.9391V39.3777C10 40.2979 10.7426 41.0405 11.6629 41.0405H25.224C25.4016 42.3159 26.4994 43.3007 27.8393 43.3007C29.1632 43.3007 30.261 42.3159 30.4547 41.0405H43.9351C44.8553 41.0405 45.598 40.2979 45.598 39.3777V18.9391C45.5818 18.0189 44.823 17.2762 43.919 17.2762Z",
    fill: "#5599FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M12.2764 16.2108V37.6665C12.2764 38.3445 12.8253 38.8773 13.4872 38.8773H42.2239C42.9019 38.8773 43.4347 38.3284 43.4347 37.6665V16.2108C43.4347 15.5328 42.8858 15 42.2239 15H13.4872C12.8091 15 12.2764 15.5489 12.2764 16.2108Z",
    fill: "#F5F8FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7082 18.5678H14.4072V19.4719H25.7082V18.5678Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7082 21.8127H14.4072V22.7168H25.7082V21.8127Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7082 25.058H14.4072V25.9621H25.7082V25.058Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7082 28.3029H14.4072V29.2069H25.7082V28.3029Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7082 31.5478H14.4072V32.4519H25.7082V31.5478Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7082 34.7927H14.4072V35.6968H25.7082V34.7927Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1584 18.5678H29.8574V19.4719H41.1584V18.5678Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1584 21.8127H29.8574V22.7168H41.1584V21.8127Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1584 25.058H29.8574V25.9621H41.1584V25.058Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1584 28.3029H29.8574V29.2069H41.1584V28.3029Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1584 31.5478H29.8574V32.4519H41.1584V31.5478Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1584 34.7927H29.8574V35.6968H41.1584V34.7927Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelfLearningBook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/selfLearningBook.2f1f7b79.svg";
export { ForwardRef as ReactComponent };